type RewardFeatureCardProps = {
  icon: string;
  title: string;
  description: string;
};

export const RewardFeatureCard = ({
  icon,
  title,
  description,
}: RewardFeatureCardProps) => {
  return (
    <div>
      <div className="hidden lg:block">
        <div
      className="
        flex items-center gap-4
        rounded-[28px]
        border border-white
        bg-[linear-gradient(135deg,rgba(245,230,230,0.72)_0%,rgba(245,230,230,0.62)_100%)]
        shadow-[0px_8px_28px_rgba(0,0,0,0.06)]
        px-4 py-4
        min-h-[112px]
      "
    >
      <div
        className="
          w-[72px] h-[72px]
          rounded-[22px]
          border-2 border-[#FF0000]
          bg-[#F7ECEC]
          flex items-center justify-center
          shrink-0
        "
      >
        <img
          src={icon}
          alt=""
          className="w-[55px] h-[55px] object-contain"
          aria-hidden="true"
        />
      </div>

      <div>
        <h3 className="text-[#111111] text-[18px] leading-[1.2] font-medium">
          {title}
        </h3>

        <p className="mt-2 text-[#2B2B2B] text-[15px] leading-[1.4]">
          {description}
        </p>
      </div>
    </div>
      </div>

      <div className="block lg:hidden">
        <div
      className="
        flex items-center gap-2
        rounded-[28px]
        border-4 border-solid border-white
        bg-[linear-gradient(135deg,rgba(245,230,230,0.72)_0%,rgba(245,230,230,0.62)_100%)]
        
        
        
      "
    >
      <div
        className="
          w-[72px] h-[72px]
          rounded-[22px]
          border-2 border-[#FF0000]
          bg-[#F7ECEC]
          flex items-center justify-center
          shrink-0
        "
      >
        <img
          src={icon}
          alt=""
          className="w-[28px] h-[28px] object-contain"
          aria-hidden="true"
        />
      </div>

      <div>
        <h3 className="text-[#111111] text-[14px] leading-[1.2] font-medium">
          {title}
        </h3>

        <p className="mt-2 text-[#2B2B2B] text-[12px] leading-[1.4]">
          {description}
        </p>
      </div>
    </div>
      </div></div>
   
    
  );
};